import api from './api';
import publicApi from './publicApi';

export const getAuth = async() => {
    try{
        const response = await publicApi.get('/get_map_auth')
        // console.log(response)
        return response
    }
    catch(error){
        console.error(error)
    }
}

export const getAddressUsingPincode = async(data) => {
    try{
    const response = await publicApi.post('/get_pincode_address',data);
    // console.log(response)
    return response.data
    }
    catch(error){
        console.error(error)
    }
}
